import { render, staticRenderFns } from "./AdSection.vue?vue&type=template&id=bd85a7e6&scoped=true&"
import script from "./AdSection.vue?vue&type=script&lang=js&"
export * from "./AdSection.vue?vue&type=script&lang=js&"
import style0 from "./AdSection.vue?vue&type=style&index=0&id=bd85a7e6&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd85a7e6",
  null
  
)

export default component.exports